var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioDes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 30.593 5.215)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a.982.982 0 01-.98-.982v-7.524c0-.541.439-.982.98-.982h7.527c.543 0 .983.441.983.982v7.524c0 .541-.44.982-.983.982H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 30.593 256)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.652 0-1.182.529-1.182 1.184v7.523c0 .652.53 1.182 1.182 1.182h7.527c.653 0 1.182-.53 1.182-1.182V1.184C8.709.529 8.18 0 7.527 0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 60.973 203.832)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.795 0-1.439 1.314-1.439 2.936 0 1.621.644 2.935 1.439 2.935h5.133c.795 0 1.439-1.314 1.439-2.935C6.572 1.314 5.928 0 5.133 0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 131.492 110.11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a.688.688 0 100-1.377h-.18V0H0zm.07-1.979c.713 0 1.293.579 1.293 1.291C1.363.027.789.605.076.605h-.799V-1.98H.07"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 105.863 161.367)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.566v.342h-.948L-1.732 0h-.831l1.856 2.586H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 91.304 138.57)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.596L0 .926V0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 205.954 94.387)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.318c.359-.357.566-.846.566-1.354 0-.451-.162-.882-.449-1.224H.104c.255.351.398.781.398 1.224C.502-.855.32-.375 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 189.12 94.387)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.318c.359-.357.566-.846.566-1.354 0-.451-.162-.882-.449-1.224H.102A2.077 2.077 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.88211 0 0 -25.88211 172.236 94.387)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.316c.359-.357.564-.846.564-1.354 0-.451-.162-.882-.447-1.224H.104A2.075 2.075 0 010 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDes);
export default __webpack_public_path__ + "static/media/AudioDes.98ef6c875c09f6c5275a5e39ca1ce9e8.svg";
export { ForwardRef as ReactComponent };